import { render } from "./Lobby.vue?vue&type=template&id=7f4ccdaa&scoped=true&bindings={\"inviteID\":\"props\",\"opponentChoosingName\":\"data\",\"showPlayerLeft\":\"data\",\"menuState\":\"options\",\"setMenuState\":\"options\",\"goBack\":\"options\",\"playHotSeat\":\"options\"}"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"

import "./Lobby.vue?vue&type=style&index=0&id=7f4ccdaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f4ccdaa"

export default script